export { CollectibleGiftMessage } from './CollectibleGiftMessage'
